const formatWeight = weightInLbs =>
    (weightInLbs ? `${Math.floor(weightInLbs / 14)}-${weightInLbs % 14}` : null);

export default formatWeight;



// WEBPACK FOOTER //
// ./src/js/utils/formatWeight.js